import React from "react";


const About = (props) => {
	return (
		<section id="about">
		<div className="cs-height_70 cs-height_lg_40"></div>
		<div className="container">
		  <div className="row align-items-center flex-column-reverse-lg">
		  <div className="col-lg-7 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
			  <div className="cs-height_0 cs-height_lg_40"></div>
			  <div className="cs-right_space_150">
				<div className="cs-seciton_heading cs-style1 text-uppercase">
				  <h3 className="cs-section_title cs-font_16 cs-font_14_sm cs-gradient_color">Join the family...</h3>
				  <h2 className="cs-section_subtitle cs-m0 cs-font_36 cs-font_24_sm">Meet the JailFrogs</h2>
				</div>
				<div className="cs-height_20 cs-height_lg_20"></div>
				<p>
				  We have crafted 10,000 bad ass jailpepes with attitude from over 35 'legendary' seed pepes, spawning over 250 attributes, including skins, smokes and other wild paraphenalia you will love and providing unique 1/1 VivaLaVandal PEPEs on a selection of dope backgrounds.
				</p>
				<p>Utilising much loved traits from the finest of borgoise NFT culture (see RAREPEPES among others) a Dash of FAKERY, much frog love - and to mention hundreds of hours of toil and torment; We are proud to present our collection to the finest connoisseurs of frogdom and the NFT family.</p>
				<p>Of course, these Pepes are CC0 and you are free to use and meme them as you please.</p>
				<div className="cs-height_25 cs-height_lg_15"></div>
				<div className="cs-btn_group">
				  <a href={props.discord} target="_blank" rel="noreferrer" className="cs-btn cs-btn_filed cs-primary_btn">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="https://www.w3.org/2000/svg">
					  <path d="M13.4687 9C14.6539 9 15.7906 9.47081 16.6286 10.3089C17.4667 11.1469 17.9375 12.2836 17.9375 13.4688C17.9375 14.6539 17.4667 15.7906 16.6286 16.6286C15.7906 17.4667 14.6539 17.9375 13.4687 17.9375C12.2835 17.9375 11.1469 17.4667 10.3089 16.6286C9.4708 15.7906 8.99998 14.6539 8.99998 13.4688C8.99998 12.2836 9.4708 11.1469 10.3089 10.3089C11.1469 9.47081 12.2835 9 13.4687 9ZM9.01867 10.6242C8.4747 11.4728 8.18617 12.4599 8.18749 13.4679C8.18749 14.8045 8.68311 16.0241 9.5013 16.9544C8.84967 17.0681 8.14036 17.125 7.37499 17.125C5.02686 17.125 3.20848 16.592 1.93936 15.5C1.60661 15.2141 1.33953 14.8597 1.1564 14.461C0.973256 14.0623 0.878373 13.6288 0.878235 13.1901V12.4523C0.87845 11.9676 1.07115 11.5028 1.41397 11.1602C1.75678 10.8175 2.22165 10.625 2.70636 10.625H9.01867V10.6242ZM13.4687 10.6242L13.3956 10.6307C13.3144 10.6455 13.2397 10.6847 13.1814 10.7431C13.123 10.8014 13.0838 10.8761 13.069 10.9573L13.0625 11.0304V13.0617H11.0296L10.9565 13.069C10.8753 13.0838 10.8006 13.123 10.7422 13.1814C10.6839 13.2397 10.6447 13.3145 10.6299 13.3956L10.6234 13.4688L10.6299 13.5419C10.6448 13.6229 10.6841 13.6975 10.7424 13.7556C10.8008 13.8138 10.8754 13.8529 10.9565 13.8677L11.0296 13.875L13.0633 13.8742V15.9087L13.0698 15.9818C13.0847 16.0631 13.124 16.1379 13.1825 16.1963C13.241 16.2546 13.3159 16.2938 13.3972 16.3084L13.4704 16.3149L13.5435 16.3084C13.6245 16.2935 13.6991 16.2542 13.7573 16.1959C13.8154 16.1375 13.8545 16.0629 13.8693 15.9818L13.8766 15.9087L13.875 13.8742H15.9095L15.9826 13.8677C16.0638 13.8529 16.1385 13.8137 16.1969 13.7553C16.2552 13.697 16.2944 13.6222 16.3092 13.5411L16.3157 13.4679L16.3092 13.3948C16.2943 13.3138 16.255 13.2392 16.1967 13.181C16.1383 13.1229 16.0637 13.0838 15.9826 13.069L15.9095 13.0625L13.875 13.0609V11.0296L13.8685 10.9565C13.8537 10.8753 13.8145 10.8006 13.7561 10.7422C13.6978 10.6839 13.623 10.6447 13.5419 10.6299L13.4687 10.6234V10.6242ZM7.37499 0.875001C7.52238 0.87481 7.66485 0.92805 7.776 1.02486C7.88715 1.12166 7.95944 1.25547 7.97949 1.4015L7.98517 1.48438L7.98436 2.09294H10.8281C11.313 2.09294 11.7779 2.28554 12.1208 2.62838C12.4636 2.97122 12.6562 3.43621 12.6562 3.92106V7.58138C12.6562 7.82594 12.6083 8.05994 12.5214 8.27281C11.6259 8.43475 10.7878 8.82674 10.0895 9.41031H3.92267C3.43782 9.41031 2.97283 9.21771 2.62999 8.87487C2.28715 8.53203 2.09455 8.06704 2.09455 7.58219V3.92188C2.09455 3.43717 2.28704 2.9723 2.62971 2.62948C2.97237 2.28667 3.43715 2.09397 3.92186 2.09375L6.7648 2.09294V1.48438C6.76482 1.35095 6.80863 1.22122 6.8895 1.1151C6.97038 1.00898 7.08384 0.93234 7.21249 0.896938L7.29211 0.880688L7.37499 0.875001ZM5.54686 4.53125C5.41018 4.52578 5.2738 4.54798 5.1459 4.59651C5.01801 4.64504 4.90124 4.71891 4.80259 4.81369C4.70395 4.90846 4.62547 5.02219 4.57186 5.14804C4.51825 5.27389 4.49062 5.40927 4.49062 5.54606C4.49062 5.68286 4.51825 5.81824 4.57186 5.94409C4.62547 6.06994 4.70395 6.18366 4.80259 6.27844C4.90124 6.37321 5.01801 6.44708 5.1459 6.49561C5.2738 6.54415 5.41018 6.56635 5.54686 6.56088C5.80898 6.55038 6.05687 6.43888 6.23862 6.24971C6.42037 6.06054 6.52187 5.80839 6.52187 5.54606C6.52187 5.28373 6.42037 5.03158 6.23862 4.84241C6.05687 4.65325 5.80898 4.54174 5.54686 4.53125ZM9.19661 4.53125C9.05993 4.52578 8.92355 4.54798 8.79565 4.59651C8.66776 4.64504 8.55099 4.71891 8.45234 4.81369C8.3537 4.90846 8.27522 5.02219 8.22161 5.14804C8.168 5.27389 8.14037 5.40927 8.14037 5.54606C8.14037 5.68286 8.168 5.81824 8.22161 5.94409C8.27522 6.06994 8.3537 6.18366 8.45234 6.27844C8.55099 6.37321 8.66776 6.44708 8.79565 6.49561C8.92355 6.54415 9.05993 6.56635 9.19661 6.56088C9.45873 6.55038 9.70662 6.43888 9.88837 6.24971C10.0701 6.06054 10.1716 5.80839 10.1716 5.54606C10.1716 5.28373 10.0701 5.03158 9.88837 4.84241C9.70662 4.65325 9.45873 4.54174 9.19661 4.53125Z" fill="currentColor"></path>
					</svg>
					<span>Join the frog army early</span>
				  </a>
				</div>
			  </div>
			</div>
			<div className="col-lg-5 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
			  <div className="row text-center">
				<div className="col-4">
				  <div className="cs-height_60 cs-height_lg_30"></div>
				  <img src="/assets/img/pepes/1.png" alt=""/>
				  <div className="cs-height_25 cs-height_lg_25"></div>
				  <img src="/assets/img/pepes/2.png" alt=""/>
				</div>
				<div className="col-4">
				<div className="cs-height_60 cs-height_lg_30"></div>
				  <img src="/assets/img/pepes/7.png" alt=""/>
				  <div className="cs-height_25 cs-height_lg_25"></div>
				  <img src="/assets/img/pepes/4.png" alt=""/>
				</div>
				<div className="col-4">
				<div className="cs-height_60 cs-height_lg_30"></div>
				  <img src="/assets/img/pepes/5.png" alt=""/>
				  <div className="cs-height_25 cs-height_lg_25"></div>
				  <img src="/assets/img/pepes/6.png" alt=""/>
				</div>
			  </div>
			</div>
		  </div>
		</div>

		<div className="cs-height_40 cs-height_lg_60"></div>
		<div className="container">
		  <div className="row align-items-center flex-column-reverse-lg">
		  <div className="col-lg-7 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
				
				<div className="row text-center">
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/1410">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/2468.png" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/967">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/8655.png" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/366">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/57.png" alt=""/>
						</a>
					</div>
				</div>
				
				<div className="row text-center">
				<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/1315">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/4897.png" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/787">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/6610.png" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/1194">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/1356.png" alt=""/>
						</a>
					</div>
					
					
				</div>

				<div className="row text-center">
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x4734e795bc71513af17c466f9de5f358e44a74f0/197">
							<img src="https://arweave.net/ipTk9CG5cRMMHYpQODnf-Jm0Ad2P9oIj-geKmSs5JRE/4230.png" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/collection/alcatraz-swim-team">
							<img src="/assets/img/mystery.jpg" alt=""/>
						</a>
					</div>
					<div className="col-lg-4 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">	
						<div className="cs-height_30 cs-height_lg_15"></div>
						<a target="_blank" rel="noreferrer" href="https://opensea.io/collection/alcatraz-swim-team">
							<img src="/assets/img/mystery.jpg" alt=""/>
						</a>
					</div>
					
					
				</div>


	</div>
			
			
			<div className="col-lg-5 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
			  <div className="cs-height_0 cs-height_lg_40"></div>
			  <div className="cs-right_space_150">
				<div className="cs-seciton_heading cs-style1 text-uppercase">
				  <h3 className="cs-section_title cs-font_16 cs-font_14_sm cs-gradient_color">Shiney shiney....</h3>
				  <h2 className="cs-section_subtitle cs-m0 cs-font_36 cs-font_24_sm">Legendaries you say?</h2>
				</div>
				<div className="cs-height_20 cs-height_lg_20"></div>
				<p>
				  We'll be unveiling more as the journey unfolds...
				</p>
				
				<p>Check back soon to find out more about our legendaries</p>
				<p>Seven Legendaries have been uncovered so far:</p>
				<ul>
					<li>Seerlight</li>
					<li>Grant Yun</li>
					<li>Pepenardo</li>
					<li>AddictPepe</li>
					<li>Al Capone</li>
					<li>Farokh</li>
					<li>Indelible</li>
				</ul>

				<p>More legendaries to come soon.</p>
				<div className="cs-height_25 cs-height_lg_15"></div>
			  </div>
			</div>
			
		  </div>
		</div>
	  </section>
	);
};

export default About;
